import type { GameId, Room } from "@spieleparadies/shared";
import type { AppSocket } from "../lib/socket";

import { mountRetteAnna } from "./rette-anna";

export interface MountContext {
  socket: AppSocket;
  room: Room;
}

export interface MountedGame {
  destroy(): void;
}

type GameFactory = (container: HTMLElement, ctx: MountContext) => MountedGame;

const games: Record<string, GameFactory> = {
  "rette-anna": mountRetteAnna,
};

export function mountGame(
  gameId: GameId,
  container: HTMLElement,
  ctx: MountContext,
): MountedGame | null {
  const factory = games[gameId];
  if (!factory) return null;
  return factory(container, ctx);
}
